export default function getFormattedAmount(
  amount: number,
  options = {}
): string {
  const mergedOptions = Object.assign(
    {},
    { style: 'currency', currency: 'EUR' },
    options
  );

  return amount.toLocaleString('de-DE', mergedOptions);
}
